import { NgModule } from '@angular/core';
import { AuthorizeService } from '../../api-authorization/authorize.service';
import { HasPrivDirective, ShowAuthedDirective } from './show-authed.directive';
import { FluidHeightDirective } from './fluid-height.directive';

@NgModule({
   declarations: [
      ShowAuthedDirective,
      HasPrivDirective,
      FluidHeightDirective,
   ],
   imports: [],
   exports: [
      ShowAuthedDirective,
      HasPrivDirective,
      FluidHeightDirective,
   ],
   providers: [
      AuthorizeService,
   ],
})

export class DirectivesModule { }
